import React from 'react';
import {DisposableProductsConstant} from './DisposableProductsConstants';
import AlternatingLayout from '../shared-components/AlternatingLayout';

export default function DisposableProducts() {
    return (
        <>
        <div>
          <AlternatingLayout
            productDescription={"We deal with healthcare disposable products that are designed for single use to prevent contamination and the spread of infections. Our range includes disposable gloves, masks, gowns, caps, shoe covers, and more, all made from high-quality materials to ensure safety and comfort for both patients and healthcare professionals."}
            data={DisposableProductsConstant.dataDisposableGloves}
            landScapeImg={false}
            />
        </div>
        </>
    );
}